import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './center.less';

const Center = ({ children, className }) => (
  <div className={classNames(styles.center, className)}>{children}</div>
);

Center.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Center.defaultProps = {
  children: null,
  className: '',
};

export default Center;
